import Connect from './Connect/Connect';
import RunCommand from './RunCommand/RunCommand';
import Input from './Input/Input';
import Disconnect from './Disconnect/Disconnect';
import {types} from './types';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Param       showAlert -  show alert
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function Actions(action, showAlert, variables, setOpenVariable, variableRender, automId, automVersionId) {
    switch (action.actionName) {
        case types.CONNECT:
            return <Connect automId={automId} action={action} showAlert={showAlert} variables={variables}
                            setOpenVariable={setOpenVariable} automVersionId={automVersionId}/>;
        case types.DISCONNECT:
            return <Disconnect action={action}/>;
        case types.RUNCOMMAND:
            return <RunCommand automId={automId} action={action} showAlert={showAlert} variables={variables}
                               setOpenVariable={setOpenVariable} automVersionId={automVersionId}/>;
        case types.INPUT:
            return <Input automId={automId} action={action} showAlert={showAlert} variables={variables}
                          setOpenVariable={setOpenVariable} automVersionId={automVersionId}/>;
        default:
            break;
    }
}

export default Actions;
